import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { QuestionFormError, QuestionFormValidation } from "./types";

// const initialState
export const initialState: QuestionFormValidation = { questionFormErrors: {} };

export const questionFormValidationSlice = createSlice({
  name: "questionFormValidation",
  initialState,
  reducers: {
    setQuestionFormError(
      state,
      action: PayloadAction<{
        blockId: string;
        error: QuestionFormError;
      }>
    ) {
      state.questionFormErrors[action.payload.blockId] = action.payload.error;
    },
    clearQuestionFormError(
      state,
      action: PayloadAction<{
        blockId: string;
      }>
    ) {
      const { blockId } = action.payload;
      if (!state.questionFormErrors[blockId]) return;
      delete state.questionFormErrors[blockId];
    },
  },
});

export const { setQuestionFormError, clearQuestionFormError } =
  questionFormValidationSlice.actions;

export const questionFormValidationReducer =
  questionFormValidationSlice.reducer;
